// Indian number-to-words — lakhs, crores
const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function twoDigits(n) {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return TENS[t] + (o ? '-' + ONES[o] : '');
}

function threeDigits(n) {
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const parts = [];
  if (h) parts.push(ONES[h] + ' Hundred');
  if (rest) parts.push(twoDigits(rest));
  return parts.join(' ');
}

export function amountInWords(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return '';
  const neg = amount < 0;
  let n = Math.abs(Math.floor(amount));
  const paise = Math.round((Math.abs(amount) - n) * 100);
  if (n === 0 && paise === 0) return 'Rupees Zero Only';

  const parts = [];
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  const hundred = n;

  if (crore) parts.push((crore >= 100 ? threeDigits(crore) : twoDigits(crore)) + ' Crore');
  if (lakh) parts.push(twoDigits(lakh) + ' Lakh');
  if (thousand) parts.push(twoDigits(thousand) + ' Thousand');
  if (hundred) parts.push(threeDigits(hundred));

  let out = 'Rupees ' + (neg ? 'Minus ' : '') + parts.join(' ');
  if (paise) out += ' and ' + twoDigits(paise) + ' Paise';
  out += ' Only';
  return out.replace(/\s+/g, ' ').trim();
}
